import { useTrackers } from '@ps/web-shared-analytics';
import { useDispatch } from 'react-redux';

import { useWidget } from '@swf/core/hooks/useWidget';
import type { Dispatch } from '@swf/core/store';
import type { CasinoGame, PlayType } from '@swf/core/types/CasinoGame';

interface LaunchGame {
  game: CasinoGame;
  gameCategory?: string;
  count?: number;
  launchSource?: string;
  fsbLaunch?: boolean;
  index?: number;

  onLaunch?(game: CasinoGame): void;
}

const useLaunchGame = ({
  game,
  gameCategory,
  count,
  launchSource,
  fsbLaunch,
  onLaunch,
  index
}: LaunchGame) => {
  const { casinoGameLaunched } = useTrackers();
  const { casino } = useDispatch<Dispatch>();
  const { widgetId } = useWidget();

  return (playType?: PlayType, label?: string) => {
    casinoGameLaunched({
      game: { ...game, gameCategory },
      index,
      totalGames: count,
      buttonName: label,
      playType,
      action: launchSource
    });

    if (game) {
      casino?.launch({ game, playType, fsbLaunch, widgetId });
    }

    if (onLaunch) {
      onLaunch(game);
    }
  };
};

export default useLaunchGame;
